import { Button } from "@components/atoms/Button"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Buttons",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/buttons", (props) => {
  return (
    <div className="flex gap-5 my-8 content-sized">
      <InnerBlocks
        adminClassName="flex gap-5 w-full"
        allowedBlocks={["content/button"]}
        template={[["content/button", {}]]}
        orientation="horizontal"
      />
    </div>
  )
})
